import React from 'react';
import { Subscribe } from 'unstated';
import FallbackMessageContainer from '../../state/containers/FallbackMessageContainer';
import EditFallbackMessageForm from './components/EditFallbackMessageForm';
import { RouteComponentProps } from 'react-router-dom';
import ApplicationContainer from '../../state/containers/ApplicationContainer';
import TitleStateContainer from '../../state/containers/TitleStateContainer';
import RepromptContainer from '../../state/containers/RepromptContainer';
import FollowUpContainer from '../../state/containers/FollowUpContainer';
import MediaResponseStateContainer from '../../state/containers/MediaResponseContainer';
import ConversationNavigationState from '../../models/state/ConversationNavigationState';
import NavigationBarFormPage from '../formScenes/NavigationBarFormPage';
import GenericEditContentItemPage from '../formScenes/GenericEditContentItemPage';
import FallbackMessageModel from '../../models/features/api/Fallback/FallbackMessageModel';
import IResult from '../../models/result/IResult';
import FeatureContainer from '../../state/containers/FeatureContainer';
import { FallbackFeatureTypeId } from '../../constants/featureTypeIds';
import queryString from 'query-string';
import ApplicationBackupVersionsContainer from '../../state/containers/ApplicationBackupVersionsContainer';
import ApplicationEnvironmentsContainer from '../../state/containers/ApplicationEnvironmentsContainer';

interface ApplicationRouteProps {
    applicationFeatureId: string
    fallbackMessageId: string
}
interface EditFallbackMessageProps extends RouteComponentProps<ApplicationRouteProps> { }
class EditFallbackMessage extends React.Component<EditFallbackMessageProps> {
    render() {
        return (
            <Subscribe key={this.props.match.params.fallbackMessageId + this.props.match.params.applicationFeatureId} to={[
                FallbackMessageContainer,
                ApplicationContainer,
                TitleStateContainer,
                RepromptContainer,
                FollowUpContainer,
                MediaResponseStateContainer,
                FeatureContainer,
                ApplicationEnvironmentsContainer,
                ApplicationBackupVersionsContainer]}>
                {(fallbackContainer: FallbackMessageContainer,
                    appContainer: ApplicationContainer,
                    titleContainer: TitleStateContainer,
                    repromptContainer: RepromptContainer,
                    followUpContainer: FollowUpContainer,
                    responseContainer: MediaResponseStateContainer,
                    featureContainer: FeatureContainer,
                    environmentsContainer: ApplicationEnvironmentsContainer,
                    backupsContainer: ApplicationBackupVersionsContainer) => {
                    return (
                        <GenericEditContentItemPage stateContainer={fallbackContainer}
                            environmentsContainer={environmentsContainer}
                            backupsContainer={backupsContainer}
                            titleContainer={titleContainer}
                            applicationContainer={appContainer}
                            defaultTitle="Edit Fallback Message"
                            contentItemId={this.props.match.params.fallbackMessageId}
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}
                            staticContext={this.props.staticContext}
                            featureContainer={featureContainer}
                            featureTypeId={FallbackFeatureTypeId}
                            formRender={(contentItem: FallbackMessageModel,
                                application,
                                isTemplateOwned, 
                                assistantApplication,
                                onShowPublishModal,
                                onSubmit: (model: FallbackMessageModel, onSuccess) => Promise<IResult<FallbackMessageModel>>,
                                toggleSync: (id, shouldNotSync) => Promise<IResult<FallbackMessageModel>>,
                                onAccessTypeChange) => (
                                <EditFallbackMessageForm
                                    location={this.props.location}
                                    application={application}
                                    applicationFeatureId={this.props.match.params.applicationFeatureId}
                                    appContainer={appContainer}
                                    followUpContainer={followUpContainer}
                                    repromptContainer={repromptContainer}
                                    fallbackMessage={contentItem}
                                    stateContainer={fallbackContainer}
                                    responseStateContainer={responseContainer}
                                    featureContainer={featureContainer}
                                    assistantApplication={assistantApplication}
                                    onShowPublishModal={onShowPublishModal}
                                    onAccessTypeChange={onAccessTypeChange}
                                    onSubmit={onSubmit}
                                    onToggleSync={toggleSync}
                                    previousContentId={queryString?.parse(this.props.location.search)?.previousContentId as string}
                                    history={this.props.history}
                                    isSaving={fallbackContainer.state.isSaving}
                                    isTemplateOwned={isTemplateOwned} />
                            )} />
                    );
                }}
            </Subscribe>
        );
    }
}

export default EditFallbackMessage;